export const DEFAULT_TITLE = 'Оценка от Циан';
export const DEFAULT_DESCRIPTION =
  'Из нашей базы в 2,5 млн объявлений и сделок выбираем только похожие квартиры, и на их основе расчитываем оценку';
